import { Injectable } from "@angular/core";
import { Router, CanActivate } from "@angular/router";
import { AuthService } from "../services/auth.service";

@Injectable()
export class AdminGaurd implements CanActivate {
  constructor(private router: Router, private authService: AuthService) { }

  canActivate() {
    const isAuthorized = localStorage.getItem("admin");

    if (isAuthorized) {
      return true;
    }

    const password = prompt("Please enter password");

    if (password === "yaro13060612"|| password==="chicken1212") {
      localStorage.setItem("admin", "true");

      return true;
    }
  }
}
